/* assets/wishlist.js
   LocalStorage wishlist: stores array of product handles under key 'dw_wishlist'
*/
(function () {
  const STORAGE_KEY = 'dw_wishlist';
  const SELECTOR_TOGGLE = '.js-wishlist-toggle';
  const SELECTOR_COUNT = '#wishlist-badge-count'; // optional header badge
  const PAGE_CONTAINER = document.getElementById('wishlist-items');
  const EMPTY_CONTAINER = document.getElementById('wishlist-empty');
  const COUNT_CONTAINER = document.getElementById('wishlist-count');

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    broadcastWishlistChange();
  }

  function isInWishlist(handle) {
    const list = getWishlist();
    return list.indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      setWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    let list = getWishlist();
    list = list.filter(h => h !== handle);
    setWishlist(list);
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) removeFromWishlist(handle);
    else addToWishlist(handle);
    updateAllToggles();
    updateHeaderCount();
  }

  function updateAllToggles() {
    document.querySelectorAll(SELECTOR_TOGGLE).forEach(btn => {
      const h = btn.dataset.productHandle;
      const pressed = isInWishlist(h);
      btn.setAttribute('aria-pressed', String(pressed));
      btn.classList.toggle('is-wishlisted', pressed);
      btn.title = pressed ? 'Remove from wishlist' : 'Add to wishlist';
    });
  }

  function updateHeaderCount() {
    const count = getWishlist().length;
    // update optional badge
    const badge = document.querySelector(SELECTOR_COUNT);
    if (badge) badge.textContent = count;
    // page-specific count element
    if (COUNT_CONTAINER) {
      COUNT_CONTAINER.style.display = count ? 'block' : 'none';
      COUNT_CONTAINER.textContent = `Wishlist (${count})`;
    }
  }

  // render wishlist page: fetch product JSON for each handle and build markup
  async function renderWishlistPage() {
    if (!PAGE_CONTAINER) return;
    const handles = getWishlist();
    if (!handles.length) {
      PAGE_CONTAINER.innerHTML = '';
      if (EMPTY_CONTAINER) EMPTY_CONTAINER.style.display = 'block';
      return;
    }
    EMPTY_CONTAINER && (EMPTY_CONTAINER.style.display = 'none');

    // Build markup progressively
    PAGE_CONTAINER.innerHTML = '<div class="wishlist-loading">Loading items...</div>';
    const promises = handles.map(handle => fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null).catch(()=>null));
    const products = (await Promise.all(promises)).filter(Boolean);

    const itemsHtml = products.map(product => {
      // Use first variant & first image for quick card
      const img = (product.images && product.images[0]) ? product.images[0] : '';
      const price = product.variants && product.variants[0] ? (product.variants[0].price / 100).toFixed(2) : '';
      return `
        <div class="wishlist-card" data-handle="${product.handle}">
          <a class="wishlist-card__image" href="${product.url || '/products/' + product.handle}">
            <img src="${img}" alt="${escapeHtml(product.title)}" loading="lazy" />
          </a>
          <div class="wishlist-card__meta">
            <a class="wishlist-card__title" href="${product.url || '/products/' + product.handle}">${escapeHtml(product.title)}</a>
            <div class="wishlist-card__price">${price ? '₹' + price : ''}</div>
            <div class="wishlist-card__actions">
              <button class="btn-wishlist js-wishlist-toggle" data-product-handle="${product.handle}" aria-pressed="true">Remove</button>
              <a class="btn btn--primary" href="/cart/add?id=${product.variants[0]?.id || ''}">Add to cart</a>
            </div>
          </div>
        </div>
      `;
    }).join('');

    PAGE_CONTAINER.innerHTML = '<div class="wishlist-grid">' + itemsHtml + '</div>';

    // rebind remove buttons on wishlist page
    document.querySelectorAll('.wishlist-card .js-wishlist-toggle').forEach(btn => {
      btn.addEventListener('click', function(e) {
        const handle = btn.dataset.productHandle;
        removeFromWishlist(handle);
        // remove DOM item
        const card = btn.closest('.wishlist-card');
        card && card.remove();
        updateAllToggles();
        updateHeaderCount();
        if (!getWishlist().length && EMPTY_CONTAINER) EMPTY_CONTAINER.style.display = 'block';
      });
    });
  }

  // small helper to escape HTML
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>"']/g, function(m) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[m]; });
  }

  // broadcast wishlist changes to other tabs
  function broadcastWishlistChange() {
    try {
      localStorage.setItem(STORAGE_KEY + '_updated_at', Date.now());
    } catch (e) {}
  }

  // listen for storage events (other tabs)
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY + '_updated_at') {
      updateAllToggles();
      updateHeaderCount();
      renderWishlistPage();
    }
  });

  // bind toggle buttons globally
  function bindToggles() {
    document.querySelectorAll(SELECTOR_TOGGLE).forEach(btn => {
      btn.removeEventListener('click', btn.__wishlist_click); // remove previous if any
      const handler = function () {
        const handle = btn.dataset.productHandle;
        toggleWishlist(handle);
      };
      btn.addEventListener('click', handler);
      btn.__wishlist_click = handler;
    });
  }

  // initial boot
  function init() {
    updateAllToggles();
    updateHeaderCount();
    bindToggles();
    // If on wishlist page, render items
    if (PAGE_CONTAINER) {
      renderWishlistPage();
    }
    // observe DOM changes in case product cards are rendered later (AJAX)
    const observer = new MutationObserver((mutations) => {
      // rebind when new toggles appear
      if (document.querySelectorAll(SELECTOR_TOGGLE).length) {
        bindToggles();
        updateAllToggles();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
